import React from 'react';
import PropTypes from 'prop-types';
import { StyledAddButton, PlusIcon } from './styled';

const AddButton = ({ children = undefined, startIcon = <PlusIcon />, ...rest }) => (
  <StyledAddButton startIcon={ startIcon } { ...rest }>
    { children }
  </StyledAddButton>
);

AddButton.propTypes = {
  children: PropTypes.node,
  startIcon: PropTypes.node
};

export default AddButton;
